export interface InjectLocationInJobRequest{
    JobList: string[];
    UnassignedLocation: string[];
    ConnectionId: string;
}